import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
	ReviewsSection,
	ReviewContainer,
	Review,
	ReviewTitle,
	ReviewParagraph,
} from './styles'

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => <ReviewParagraph>{children}</ReviewParagraph>,
	},
}

const Reviews = ({ data }) => {

	return (
		<ReviewsSection>
			<ReviewContainer>
				{data?.items.map((item, i) => {
					return (
						<Review key={i}>
							{documentToReactComponents(item.body.json, options)}
							<ReviewTitle>{item.name}</ReviewTitle>
						</Review>
					)
				})}
			</ReviewContainer>
		</ReviewsSection>
	)
}

export default Reviews
